/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetFavoriteRequest } from '../../models/set-favorite-request';

export interface DashboardFavoritesDashboardIdUserPost$Params {
  dashboardId: string;
      body?: SetFavoriteRequest
}

export function dashboardFavoritesDashboardIdUserPost(http: HttpClient, rootUrl: string, params: DashboardFavoritesDashboardIdUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, dashboardFavoritesDashboardIdUserPost.PATH, 'post');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

dashboardFavoritesDashboardIdUserPost.PATH = '/dashboard-favorites/{dashboardId}/user';
